import React from "react";

export function AvatarSuchAsIcon(props) {
    return (
        <div className={"avatar-content " + (props.avatarClass??'')} style={{cursor: 'default'}}>
            { props.icon }
        </div>
    )
}